// extracted by mini-css-extract-plugin
module.exports = {"columnSelector":"Selector_columnSelector__O90_K","current":"Selector_current__iwj2Z","alternative":"Selector_alternative__7n25b"};